<template>
    <div>
        <div class="mb-5 pt-4 screenWidth ">
            <div class="row pt-2">
                <div class="col-12 col-md-7">
                    <Loading
                        v-if="loadingMain"
                        height="400px"
                    />
                    <NoData
                        v-else-if="articleMain.length === 0 && !loadingNew"
                        class="py-3"
                    />
                    <SliderMainArticle
                        v-else
                        :articleRes="articleMain"
                        :gaInfo="`${gaData}主要內容|`"
                        class="mb-md-3"
                    />
                    <div class="btnBlock mx-auto mb-2">
                        <!-- <router-link :to="{ name: 'ranking', params: { page: 1, sort: 'new', category: '' } }">
                            <button type="button"
                                    class="btn btn-sec search__btn d-inline-block rounded-pill pt-2 w-100"
                                    :data-ga-element="`${gaData}最新內容|觀看更多`">
                                觀看更多
                            </button>
                        </router-link> -->
                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <!-- 精選內容 -->
                    <div style="clear:both" />
                    <Loading
                        v-if="loading"
                        :height="'100px'"
                    />
                    <div
                        v-for="item in articleCollection"
                        :key="item.contentSeq"
                        class="d-block"
                    >
                        <ArticleList
                            :article="item"
                            :gaInfo="`${gaData}精選內容|`"
                            :type="'s'"
                        />
                    </div>
                    <NoData
                        v-if="articleCollection.length === 0 && !loading"
                        class="py-3"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <TabList
                        :articleList1="articleCollection"
                        :articleList2="articleList"
                        gaData="健康及保險知識+|首頁|"
                        :tabData="[ {name:'最新文章', article:articleRes }, {name:'熱門推薦', article:articleList },]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { post } from '@/api';
import SliderMainArticle from './SliderMainArticle.vue';
import TabList from './TabList.vue';
import ArticleList from '@/components/ArticleList.vue';
import NoData from '@/components/NoData.vue';
// import Theme from '@/components/Theme.vue';
import Loading from '@/components/Loading.vue';
import moment from 'moment';

export default {
    name: 'HomePage',
    components: {
        TabList,
        SliderMainArticle,
        ArticleList,
        Loading,
        NoData,
    },
    data() {
        return {
            loading: false,
            loadingNew: false,
            loadingHot: false,
            loadingMain: false,
            contentPage: '首頁',
            articleCollection: [],
            articleList: [],
            articleRes: [],
            articleMain: [],
            isShowSlider: true,
        };
    },
    computed: {
        gaData() {
            return this.systemName + '|' + this.contentPage + '|';
        },
    },
    created() {
        this.hotArticles();
        this.newArticles();
        this.mainArticles();
        this.collectionArticles();
    },
    methods: {
        // 熱門內容
        hotArticles() {
            this.loadingHot = true;
            const today = moment().format('YYYY-MM-DD');
            const lastMonth = moment().subtract(30, 'days').format('YYYY-MM-DD');
            const hotArticles = {
                conditions: [
                    {
                        column: 'state',
                        value: 'ON',
                        operator: 'eq'
                    },
                ],
                checkStartDate: lastMonth,
                checkEndDate: today,
                sortBy: ['viewCounts', 'onDate'],
                sortDesc: [true, true],
                size: 8,
            };
            post('/api/content/list', hotArticles)
                .then((res) => {
                    this.articleList = [];
                    if (res.status === 200) {
                        if (res.response.contents) {
                            this.articleList = res.response.contents;
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loadingHot = false;
                });
        },
        // 最新內容
        newArticles() {
            this.loadingNew = true;
            const newArticle = {
                sortBy: ['onDate'],
                sortDesc: [true],
                conditions: [
                    {
                        column: 'state',
                        value: 'ON',
                        operator: 'eq'
                    },
                ],
                size: 5,
            };
            // 最新內容
            post('/api/content/list', newArticle)
                .then((res) => {
                    this.articleRes = [];
                    if (res.status === 200) {
                        if (res.response.contents) {
                            this.articleRes = res.response.contents;
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loadingNew = false;
                });
        },
        // 主視覺文章
        mainArticles() {
            this.loadingMain = true;
            const mainArticle = {
                sortBy: ['bannerContentSort'],
                sortDesc: [false],
                conditions: [
                    {
                        column: 'bannerContentSort',
                        value: '1',
                        operator: 'gte'
                    },
                    {
                        column: 'bannerContentSort',
                        value: '5',
                        operator: 'lte'
                    },
                    {
                        column: 'state',
                        value: 'ON',
                        operator: 'eq'
                    },
                ],
                size: 5,
            };
            // 主視覺內容
            post('/api/content/list', mainArticle)
                .then((res) => {
                    this.articleMain = [];
                    if (res.status === 200) {
                        if (res.response.contents) {
                            this.articleMain = res.response.contents;
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loadingMain = false;
                });
        },
        // 精選內容
        collectionArticles() {
            this.loading = true;
            const collection = {
                conditions: [
                    {
                        column: 'featuredSort',
                        value: '1',
                        operator: 'gte'
                    },
                    {
                        column: 'featuredSort',
                        value: '4',
                        operator: 'lte'
                    },
                    {
                        column: 'state',
                        value: 'ON',
                        operator: 'eq'
                    },
                ],
                sortBy: ['featuredSort'],
                sortDesc: [false],
                size: 4,
            };
            // 精選內容
            post('/api/content/list', collection)
                .then((res) => {
                    this.articleCollection = [];
                    if (res.status === 200) {
                        if (res.response.contents) {
                            this.articleCollection = res.response.contents;
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loading = false;
                });
        },
        sliderHandler(showSlider) {
            this.isShowSlider = showSlider;
        }
    },
};
</script>
<style lang="scss" scoped>
.image {
    height: 100px;
    background-position: center center;
    background-size: auto 100px cover;
    border: 0;
    background-repeat: no-repeat;
}
.list {
    list-style: none;
    width: 100%;
    &.underline {
        border-bottom: 1px solid $gray-300;
    }
    .list__index {
        font-size: 1.875rem;
        color: $info;
        font-weight: 700;
    }
    .list__title {
        width: 100%;
        font-size: 1.125rem;
        color: $gray-600;
        @extend %ellipsis-single;
        margin-top: 0.625rem;
    }
}
.btnBlock {
    width: 100%;
    max-width: 24rem;
    @include media-breakpoint-up(md) {
        width: 50%;
    }
}
.btnBlock__sm {
    width: 100%;
    max-width: 24rem;
    margin: 0 auto;
    @include media-breakpoint-up(md) {
        width: 7.5rem;
        float: right;
    }
}
</style>
